export enum ApplicationFlag {
    NONE = 0,
    GESTION = 1,
    LABORATOIRE = 2,
    PERFORMANCE = 4,
    QSE = 8,
    MAINTENANCE = 16,
}
